// test1710
(1710 && 0);
